import { render, staticRenderFns } from "./SanteIJH.vue?vue&type=template&id=3f72a362&scoped=true&"
import script from "./SanteIJH.vue?vue&type=script&lang=js&"
export * from "./SanteIJH.vue?vue&type=script&lang=js&"
import style0 from "./SanteIJH.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteIJH.vue?vue&type=style&index=1&id=3f72a362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f72a362",
  null
  
)

export default component.exports